import { InputNumber } from 'antd';
import styles from '../RichTextEditor.module.scss';
import { useCallback, useState } from 'react';
import { $patchStyleText } from '@lexical/selection';
import { $getSelection, $isRangeSelection, LexicalEditor } from 'lexical';
import { ToolbarButtonProps } from './ToolbarButton';

export function applyFontSize(size: number) {
  const selection = $getSelection();
  if ($isRangeSelection(selection)) {
    $patchStyleText(selection, { 'font-size': `${size}px` });
  }
}

export function useFontSize(editor: LexicalEditor) {
  const [selectedSize, setSelectedSize] = useState<number>(14);

  const selectFont = useCallback(
    (size: number) => {
      setSelectedSize(size);

      editor.update(() => {
        applyFontSize(size);
      });
    },
    [editor],
  );

  return {
    onFontSizeChange: selectFont,
    selectedFontSize: selectedSize,
  };
}

export interface ToolbarFontSizeInputButtonProps extends ToolbarButtonProps {
  onFontSizeChange: (size: number) => void;
  selectedFontSize: number;
}

export function ToolbarFontSizeInputButton(
  props: ToolbarFontSizeInputButtonProps,
) {
  const { selectedFontSize, onFontSizeChange } = props;

  const onChange = (value: number | null) => {
    if (!value) return;
    onFontSizeChange(value);
  };

  return (
    <div className={styles.fontSizeInputWrapper}>
      <InputNumber
        value={selectedFontSize}
        min={10}
        max={60}
        step={2}
        size="small"
        controls={true}
        onChange={onChange}
        className={styles.fontSizeInput}
      />
    </div>
  );
}
